export default __webpack_public_path__ + "static/media/Oceania.ae94101c.png";